export const CANCELLATION_MODULES = [
    { text: "Venta",              value: "SALE" },
    { text: "Pago de venta",      value: "SALE_PAYMENT" },
    { text: "Abono a deducción",  value: "DEDUCTION_PAYMENT" },
    { text: "General",            value: "GENERAL" }
];

export function moduleLabel( value ){
    const found = CANCELLATION_MODULES.find( m => m.value === value );
    return found ? found.text : value;
}
